<template>
  <div>
    <div class="back">
      <p class="backbtn">
        <i class="el-icon-arrow-left"></i>
        <span @click="back">返回</span>
      </p>
    </div>
    <div class="content">
      <div class="title">
        <p>农民工代发薪服务</p>
      </div>
      <div class="tabs">
        <div class="tab">
          <el-tag>服务全国</el-tag>
        </div>
        <div class="tab">
          <el-tag>团建</el-tag>
        </div>
        <div class="tab">
          <el-tag>经验丰富</el-tag>
        </div>
      </div>
      <div class="buy">
        <div class="price">
          ￥ 面议
        </div>
        <el-button class="buybtn">立即购买</el-button>
      </div>
      <div class="detail">
        <p>产品详情：</p>
      </div>
    </div>
  </div>
</template>
<script>
export default ({
  name: 'demo',
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    back() {
      this.$router.back()
    }
  }
})
</script>

<style lang="less" scoped>
.backbtn {
  width: 50px;
  cursor: pointer;
  font-size: 16px;
}

.content::-webkit-scrollbar {
  width: 5px;
}

.content::-webkit-scrollbar-thumb {
  background-color: rgb(231, 231, 231);
  border-radius: 5px;
}

.content {
  overflow-y: scroll;
  width: 1000px;
  height: 700px;
  background: #F4F4F4 100%;
  padding: 20px;
  margin-left: 100px;

  .title {
    color: #000;
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 10px;
    width: 500px;
  }

  .tabs {
    width: 500px;
    display: flex;
    flex-direction: row;

    .tab {
      margin-right: 10px;
    }
  }

  .buy {
    display: flex;
    flex-direction: row;

    .price {
      color: #E22222;
      width: 500px;
      font-size: 20px;
      margin-top: 20px;
    }

    .buybtn {
      background-color: #F5A540 !important;
      color: white;
      border: 0;
      width: 200px;
      height: 50px;
    }
  }

  .detail {
    color: #000;
    margin-top: 20px;

    p {
      font-size: 18px;
    }
  }
}
</style>
